import api from '../config/api';

export const registerVisitor = async (payload) => {
  const res = await api.post('/visitor/register', payload);
  return res.data;
};

export const lookupVisitor = async (email) => {
  const res = await api.get('/visitor/lookup', { params: { email } });
  return res.data;
};
